import graphqlRequest from '../weeklyPlanner/skillsMasteryRequest';
import {
  StandardsMetadataType,
  StandardMasteryReportType,
  StandardSkillsType,
  GET_STANDARD_SKILLS,
  GET_STANDARDS_METADATA,
  GET_MASTERY_BY_STANDARD,
  GET_MASTERY_BY_UNIT,
  UnitMasteryReport,
} from './skillsMasteryQuery';

// API Function Wrappers
export async function getStandardsMetadata(
  standardSet: string,
  grade?: string
): Promise<StandardsMetadataType[]> {
  const response = await graphqlRequest<{ getStandardsMetadata: StandardsMetadataType[] }>(
    GET_STANDARDS_METADATA,
    { standardSet, grade }
  );
  return response.getStandardsMetadata;
}

export async function getMasteryByStandard(
  standardId: string[],
  studentId: string[],
  dateFrom?: string, 
  dateTo?: string
): Promise<StandardMasteryReportType[]> {
  const response = await graphqlRequest<{ getMasteryByStandard: StandardMasteryReportType[] }>(
    GET_MASTERY_BY_STANDARD,
    { standardId, studentId, dateFrom, dateTo }
  );
  return response.getMasteryByStandard;
}

export async function getStandardSkills(
  standardId: string[]
): Promise<StandardSkillsType[]> {
  const response = await graphqlRequest<{ getStandardSkills: StandardSkillsType[] }>(
    GET_STANDARD_SKILLS,
    { standardId }
  );
  return response.getStandardSkills;
}

export async function getMasteryByUnit(
  unitId: string[],
  studentId: string[],
  dateFrom?: string, 
  dateTo?: string
): Promise<UnitMasteryReport[]> {
  const response = await graphqlRequest<{ getMasteryByUnit: UnitMasteryReport[] }>(
    GET_MASTERY_BY_UNIT,
    { unitId, studentId, dateFrom, dateTo }
  );
  return response.getMasteryByUnit;
}
